<div class="price-sorting-container is-hidden-mobile">
  <div>
    <p>{{priceDisclaimerText}}</p>
  </div>
  <div class="price-sorting-button-container">
    <button mat-button class="price-sort-button" (click)="toggleSortOptions($event)">
      <span>{{priceSortButtonText}} </span>
      <mat-icon
        *ngIf="!showSortOptions"
        inline=true
        fontSet="fas"
        fontIcon="fa-chevron-down"
        ></mat-icon>
      <mat-icon
        *ngIf="showSortOptions"
        inline=true
        fontSet="fas"
        fontIcon="fa-chevron-up"
        ></mat-icon>
    </button>
    <div *ngIf="showSortOptions" class="sort-options-container">
      <div (click)="onPriceSortChange(lowToHighSortDirection)">
        {{priceLowToHighText}}
      </div>
      <div (click)="onPriceSortChange(highToLowSortDirection)">
        {{priceHighToLowText}}
      </div>
    </div>
  </div>
</div>
<div class="price-sorting-container-mobile is-hidden-tablet">
  <div><label class="filter-title">{{priceSortMobileTitle}}</label></div>
  <div><p>{{priceDisclaimerText}}</p></div>
  <mat-radio-group
    class="sort-option-radio-group"
    [(ngModel)]="currentPriceSort.sortDirection">
    <mat-radio-button class="sort-option-radio-button" [value]="lowToHighSortDirection" (change)="onPriceSortChange(lowToHighSortDirection)">
      {{priceLowToHighText}}
    </mat-radio-button>
    <mat-radio-button class="sort-option-radio-button" [value]="highToLowSortDirection" (change)="onPriceSortChange(highToLowSortDirection)">
      {{priceHighToLowText}}
    </mat-radio-button>
  </mat-radio-group>
</div>


